import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    shareholderMeetings: [],
    shareholderMeeting: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.shareholderMeetings = [];
      state.shareholderMeeting = null;
    },
    SET_SHAREHOLDER_MEETINGS(state, data) {
      state.shareholderMeetings = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_SHAREHOLDER_MEETING(state, data) {
      state.shareholderMeeting = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setShareholderMeeting({ commit }, data) {
      commit('SET_SHAREHOLDER_MEETING', data);
    },

    find({ commit, state }) {
      let url = `/shareholder_meetings?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('IR'));
          return response.body;
        })
        .then((response) => {
          commit('SET_SHAREHOLDER_MEETINGS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/shareholder_meetings/${id}`)
        .then((response) => response.body)
        .then(typeAs('IR'))
        .then((item) => {
          commit('SET_SHAREHOLDER_MEETING', item);
        });
    },

    destroy(_, id) {
      return http(`/shareholder_meetings/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/shareholder_meetings/${id}`, { method: 'PUT', data })
        : http('/shareholder_meetings', { method: 'POST', data });

      return request.then((response) => response.body);
    },
  },
};
